import clsx from 'clsx';

export interface BadgeProps {
    count: number;
    /** `action` = needs attention (orange), `neutral` otherwise. */
    tone?: 'action' | 'neutral';
    /** Visually hidden text read instead of the number, with the count in it, e.g. "3 new orders". */
    label?: string;
    className?: string;
}

/** Count bubble, capped at 99+. The caller decides whether to render it at 0. */
export const Badge = ({ count, tone = 'action', label, className }: BadgeProps) => (
    <span
        className={clsx(
            'inline-flex min-h-5 min-w-5 items-center justify-center rounded-chip px-1.5 text-micro tabular-nums',
            tone === 'action' ? 'bg-tone-action-bg text-tone-action-fg' : 'bg-tone-neutral-bg text-tone-neutral-fg',
            className
        )}
    >
        <span aria-hidden={label ? true : undefined}>{count > 99 ? '99+' : count}</span>
        {label && <span className="sr-only">{label}</span>}
    </span>
);
